import type {
    ColumnsMatching,
    ParsedDataRow,
} from 'features/my-zone/support-requests/components/support-requests-modals/modals/request-new-location/request-property/types';
import {
    getBaseHeaderKeys,
    ORIGINAL_CHALLENGE_PREFIX,
    ORIGINAL_DATA_PREFIX,
} from 'features/my-zone/support-requests/components/support-requests-modals/modals/request-new-location/request-property/flow-config/support-request-results-modal/utils';

export const transformMappedDataForResolver = (
    data: ParsedDataRow[],
    columnsMatching: ColumnsMatching | undefined,
) => {
    const requiredColumns = getBaseHeaderKeys({ columnsMatching });
    const columnsToAvoid = ['actions', 'isLoading', 'isEdited'];
    const existingColumns = Object.keys(data[0] || {}).filter(
        (column) => !columnsToAvoid.includes(column),
    );
    const additionalColumns = existingColumns
        .filter((col) => !requiredColumns.includes(col))
        .map((col) =>
            col.startsWith(ORIGINAL_CHALLENGE_PREFIX) || col.startsWith(ORIGINAL_DATA_PREFIX)
                ? col
                : `${ORIGINAL_DATA_PREFIX}${col}`,
        );

    const columns = [...requiredColumns, ...additionalColumns];

    const rows = data.map((item) => {
        return columns.map((col) => {
            if (
                [
                    'zip_code',
                    'city',
                    'street',
                    'lng',
                    'lat',
                    'state',
                    'name',
                    'formatted_address',
                    'id',
                ].includes(col)
            ) {
                return item[col] ?? null;
            }
            if (col.startsWith(ORIGINAL_DATA_PREFIX)) {
                const originalCol = col.replace(ORIGINAL_DATA_PREFIX, '');
                return item[originalCol] ?? null;
            }
            return item[col] ?? null;
        });
    });

    return { columns, rows };
};
